module.exports = __webpack_public_path__ + "img/valther-galvan.f4153b6d.png";